exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logo-box[data-v-c91830cc] {\n  width: 3.573rem;\n  height: 3.333rem;\n}\n.logo-box .logo[data-v-c91830cc] {\n  position: relative;\n}\n.logo-box .logo .b[data-v-c91830cc] {\n  width: 100%;\n  height: 100%;\n}\n.logo-box .logo .c[data-v-c91830cc] {\n  position: absolute;\n  left: 0.853rem;\n  top: 1.28rem;\n  width: 2.04rem;\n  height: 0.6rem;\n  z-index: 2;\n}\n", ""]);

// exports
